(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inntil-footer"] && !Shopify.designMode) return;
  try {
    
  // Footerens lenke for aa endre samtykke til informasjonskapsler.
  //
  // Shopifys samtykkepanel apnes med privacyBanner.showPreferences(). Er API-et
  // ikke lastet - for eksempel fordi banneret er slaatt av, eller fordi skriptet
  // ikke rakk aa laste - gjor vi ingenting, og <a href> navigerer til siden som
  // normalt. Lenken er derfor aldri dod.
  //
  // Delegert lytter paa document: footeren morfes ved kurvendringer, og en
  // lytter bundet direkte til elementet ville ikke overlevd det.
  document.addEventListener('click', (event) => {
    const lenke = event.target.closest('[data-inntil-cookie-prefs]');
    if (!lenke) return;

    const panel = window.privacyBanner;
    if (!panel || typeof panel.showPreferences !== 'function') return;

    event.preventDefault();
    panel.showPreferences();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
